import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  password: Yup.string()
    .required('Este campo é obrigatório'),
});

export default validationSchema;
